<script lang="ts" setup>
import { useVModel } from '@vueuse/core'

import { ITab } from '~/types/tab.type'

interface IProps {
  list: Array<ITab<unknown>>
  modelValue: unknown
  type?: 'underline' | 'solid'
}

const props = withDefaults(defineProps<IProps>(), {
  type: 'underline'
})
const vmValue = useVModel(props, 'modelValue')

const parsedList = computed(() => {
  return props.list.map(i => {
    return {
      ...i,
      isActive: i.value === vmValue.value
    }
  })
})

const change = (newValue: unknown) => vmValue.value = newValue
</script>

<template>
  <ul class="tab-container">
    <li
      v-for="i in parsedList"
      :key="String(i.value)"
      :class="{checked: i.isActive, [type]: type}"
      @click="change(i.value)"
    >
      <button class="tab-button">
        {{ i.label }}
        <span
          v-if="i.subText"
          class="sub-text"
        >{{ i.subText }}</span>
      </button>
      <div
        v-if="type === 'underline'"
        class="bottom-border"
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.tab-container {
  @apply flex gap-2 overflow-x-auto text-xl;

  @include sm {
    @apply text-lg;
  }

  .solid {
    .tab-button {
      @apply rounded-lg text-primary hover:bg-primary/20;

      .sub-text {
        @apply text-primary/40;
      }
    }
  }

  .tab-button {
    @apply text-primary text-opacity-40 hover:text-opacity-100 focus:text-opacity-100 transition duration-300 hover:ease-[ease] font-bold p-2 whitespace-nowrap;
    @include sm {
      @apply text-lg;
    }
  }

  .checked {
    .tab-button {
      @apply text-opacity-100;
      @include sm {
        @apply text-lg;
      }
    }

    &.solid {
      .tab-button {
        @apply bg-explorer-blue text-primary;

        .sub-text {
          @apply text-primary;
        }
      }
    }
  }

  .bottom-border {
    @apply h-1 rounded-lg;
  }

  .checked .bottom-border {
    @apply bg-explorer-blue;
  }

  @include custom-scrollbar;
}
</style>